export default [
  {
    title: 'مدیریت کالاها',
    icon: 'bx bx-chalkboard',
    children: [
      {
        title: 'کالاها',
        route: { name: 'product' },
        resource: 'ProductManager',
        action: 'show',
      },
      {
        title: 'تعرفه ها',
        route: { name: 'producttariff' },
        resource: 'ProductTariffManager',
        action: 'show',
      },
      {
        title: 'برندها',
        route: { name: 'brand' },
        resource: 'BrandManager',
        action: 'show',
      },
      {
        title: 'واحدها',
        route: { name: 'productunit' },
        resource: 'ProductUnitManager',
        action: 'show',
      },
      {
        title: 'اینکوترمزها',
        route: { name: 'purchasetype' },
        resource: 'PurchaseTypeManager',
        action: 'show',
      },
      {
        title: 'دسته بندی ها',
        route: { name: 'productcategory' },
        resource: 'ProductCategoryManager',
        action: 'show',
      },
    ],
  },
]
